import React, { useState, useCallback } from 'react';
import { Heading, InlineTextButton, IconArrowHead } from '../../components';
import classNames from 'classnames';
import css from './ListingPage.module.css';

const ExpandableSection = props => {
  const { title, children, className, ...rest } = props;

  const [isOpen, setIsOpen] = useState(true);

  const toggleOpen = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const classes = classNames(css.expandableSection, className);
  return (
    <section className={classes} {...rest}>
      <InlineTextButton
        className={css.sectionTitleWrapper}
        onClick={toggleOpen}
        aria-expanded={isOpen}
      >
        <Heading as="h2" rootClassName={css.sectionTitle}>
          {title}
        </Heading>
        <IconArrowHead className={css.expandableSectionIcon} direction={isOpen ? 'down' : 'up'} />
      </InlineTextButton>
      <div
        className={classNames(css.expandableSectionContent, {
          [css.expandableSectionContentOpen]: isOpen,
        })}
      >
        {children}
      </div>
    </section>
  );
};

export default ExpandableSection;
